const EditorState = {
    blocksSelected : [],
    blockIdClicked : null,
    mouse : {x : 0, y : 0},
    magnetPosition : {x : 0, y : 0, on : false, id : null},
    pathTmp : null,
}

export default EditorState;